import React from 'react';

interface IListIconProps {
	size?: string;
}

export const ListIcon = ({ size = '24' }: IListIconProps) => {
	return (
		<svg role="img" width={size} height={size} viewBox="0 0 24 24" fill="none" aria-labelledby="loaderIcon">
			<title id="loaderIcon">list icon</title>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4 4.5C4.82843 4.5 5.5 5.17157 5.5 6C5.5 6.82843 4.82843 7.5 4 7.5C3.17157 7.5 2.5 6.82843 2.5 6C2.5 5.17157 3.17157 4.5 4 4.5ZM21 5H7V7H21V5ZM21 11H7V13H21V11ZM5.5 12C5.5 11.1716 4.82843 10.5 4 10.5C3.17157 10.5 2.5 11.1716 2.5 12C2.5 12.8284 3.17157 13.5 4 13.5C4.82843 13.5 5.5 12.8284 5.5 12ZM21 19H7V17H21V19ZM5.5 18C5.5 17.1716 4.82843 16.5 4 16.5C3.17157 16.5 2.5 17.1716 2.5 18C2.5 18.8284 3.17157 19.5 4 19.5C4.82843 19.5 5.5 18.8284 5.5 18Z"
				fill="#3D3D3D"
			/>
		</svg>
	);
};
